/* Theme forms (contact page, footer newsletter): show "Sending…" on the submit button so shoppers
   know the form is going through. Forms opt in with data-ps-sending="<label>". */
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-ps-sending')) return;
  const button = form.querySelector('button[type="submit"]');
  if (!button || button.getAttribute('aria-busy') === 'true') return;
  // let the native submit start first, then update the button (disabling it synchronously can cancel the submit)
  setTimeout(() => {
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.textContent = form.getAttribute('data-ps-sending') || 'Sending…';
  }, 0);
});
// Back/forward cache: restore the button if the shopper navigates back to the page
window.addEventListener('pageshow', () => {
  document.querySelectorAll('form[data-ps-sending] button[aria-busy="true"]').forEach((b) => {
    b.removeAttribute('aria-busy'); b.disabled = false; if (b.dataset.label) b.textContent = b.dataset.label;
  });
});
document.querySelectorAll('form[data-ps-sending] button[type="submit"]').forEach((b) => { b.dataset.label = b.textContent; });
